// Ostatni stan urządzeń bez internetu (aplikacja ze sklepu; docs/pwa/NATYWNA.md 4 „Offline”): przy działającej
// bramie lista sztuk z bieżącymi widokami zapisana w telefonie (api/offline.ts, szyfrowana, 30 dni) od razu po każdej
// liście z bramy i potem co minutę (wcześniej dopiero po minucie - krótko otwarta APP nie zostawiała nic); przy
// starcie bez bramy wczytana do magazynu z czasem zapisu - pulpit pokazuje ostatnie wartości, a pasek „odświeżono
// HH:MM” mówi, z kiedy są. Pierwsza lista z bramy ją zastępuje.
import type { DeviceOut } from "../gen/kontrakt";
import { natywna } from "../uklad/instalacja";
import { odczytajJson, zapamietajJson } from "../api/offline";
import { odczyt, subskrybujSklad, ustawListe } from "./magazyn";

const KLUCZ = "brama/urzadzenia";
const CO_ILE_MS = 60_000;
let zegar = 0;
let odpnij: (() => void) | null = null;
let wczytanaMigawka = 0; // czas wczytanej migawki - sama migawka w magazynie nie jest zapisywana z nowym czasem

function zapisz(): void {
  if (odczyt.polaczenie() !== "jest" || !odczyt.wczytana() || odczyt.ostatnieDane() === wczytanaMigawka) return;
  void zapamietajJson(KLUCZ, odczyt.sklad().map((d) => odczyt.sztuka(d.sn) ?? d));
}

/** Start strumienia: migawka do magazynu (gdy brama jeszcze nic nie dała), zapis po liście z bramy i co minutę. */
export function zacznijMigawke(): void {
  if (!natywna()) return;
  void odczytajJson<DeviceOut[]>(KLUCZ).then((z) => {
    if (!z || odczyt.wczytana()) return;
    wczytanaMigawka = z.czas / 1000;
    ustawListe(z.dane, wczytanaMigawka);
  });
  zakonczMigawke();
  odpnij = subskrybujSklad(zapisz);
  zegar = window.setInterval(zapisz, CO_ILE_MS);
}

export function zakonczMigawke(): void {
  clearInterval(zegar);
  zegar = 0;
  odpnij?.();
  odpnij = null;
}
